import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=032ade1d&scoped=true&"
import script from "./HistoryView.vue?vue&type=script&lang=ts&"
export * from "./HistoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032ade1d",
  null
  
)

export default component.exports